import axiosInstance from "../../axios/axiosInstance";
import {
  BILLING_ADMIN_TOPUP_PACKS,
  BILLING_ADMIN_TRANSACTIONS,
  BILLING_ADMIN_VENDORS,
  BILLING_BALANCE,
  BILLING_CLAIM_TRIAL,
  BILLING_TOPUP_CREATE_ORDER,
  BILLING_TOPUP_PACKS,
  BILLING_TOPUP_VERIFY,
  BILLING_TRANSACTIONS,
} from "../../constants";

export const getTopupPacks = () => axiosInstance.get(BILLING_TOPUP_PACKS);

export const getBillingBalance = () => axiosInstance.get(BILLING_BALANCE);

export const getBillingTransactions = ({ page = 1, pageSize = 20 } = {}) =>
  axiosInstance.get(BILLING_TRANSACTIONS, { params: { page, pageSize } });

export const createTopupOrder = (topupPackCode) =>
  axiosInstance.post(BILLING_TOPUP_CREATE_ORDER, { topupPackCode });

export const verifyTopupPayment = (paymentResponse) =>
  axiosInstance.post(BILLING_TOPUP_VERIFY, paymentResponse);

export const claimTrial = () => axiosInstance.post(BILLING_CLAIM_TRIAL);

export const getAdminBillingTransactions = (params = {}) =>
  axiosInstance.get(BILLING_ADMIN_TRANSACTIONS, { params });

export const getAdminBillingVendors = (params = {}) =>
  axiosInstance.get(BILLING_ADMIN_VENDORS, { params });

export const getAdminTopupPacks = () =>
  axiosInstance.get(BILLING_ADMIN_TOPUP_PACKS);

export const createAdminTopupPack = (payload) =>
  axiosInstance.post(BILLING_ADMIN_TOPUP_PACKS, payload);

export const updateAdminTopupPackStatus = (code, payload) =>
  axiosInstance.patch(`${BILLING_ADMIN_TOPUP_PACKS}/${encodeURIComponent(code)}/status`, payload);
